import React, { useEffect, useState } from 'react';
import classes from './Admin.module.css';


const apiURI = process.env.REACT_APP_API_URI;

function AdminPage() {
    const [oldURI, setOldURI] = useState('');
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const getRequestOptions = {
            method: 'GET',
        };
        fetch(apiURI, getRequestOptions)
            .then(response => response.json())
            .then(data => {
                setOldURI(data?.url);
            })
            .catch(error => {
                console.log(error);
            });

    }, [])


    const submitHandler = async (e) => {
        e.preventDefault();

        if (url?.length > 0) {
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ url: url })
            };
            setLoading(true)
            fetch(apiURI, requestOptions)
                .then(response => response.json())
                .then(data => {
                    setLoading(false);
                    setError(false);
                    setOldURI(data?.url);
                    setSuccess(`Successful! count is: ${data?.updateCount}`);
                })
                .catch(error => {
                    setLoading(false);
                    setSuccess(false);
                    setError('Something went wrong!');
                });

        }
        setUrl('');
    }

    const handleLogOut = () => {
        localStorage.removeItem("admin");
        window.dispatchEvent(new Event("storage"));
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes.card}>
                <form onSubmit={submitHandler}>
                    <textarea
                        value={url}
                        autoFocus
                        onChange={(e) => setUrl(e.target.value)}
                        name='url'
                        id='url'
                        type="text"
                        placeholder={oldURI ? oldURI : 'Enter url'}
                    />
                    <button
                        disabled={!(url?.length > 0) || loading}
                        className={classes['my-button']}
                        type='submit'
                    >
                        {loading ? 'Loading...' : 'Submit'}
                    </button>
                </form>
            </div>

            {(success || error) ?
                <div className={classes.successMsg} style={{ backgroundColor: `${success ? 'rgb(68, 225, 68)' : 'red'}` }}>
                    {success || error || null}
                </div>
                :
                null}

            <button
                onClick={handleLogOut}
                className={classes.logout}
            >
                Logout
            </button>

        </div>
    )
}

export default AdminPage;
